export default __webpack_public_path__ + "static/media/anamicaam.edb338aa.jpg";